import { render, staticRenderFns } from "./EmployeesPage.vue?vue&type=template&id=fd7c33d0&scoped=true"
import script from "./EmployeesPage.vue?vue&type=script&lang=js"
export * from "./EmployeesPage.vue?vue&type=script&lang=js"
import style0 from "./EmployeesPage.vue?vue&type=style&index=0&id=fd7c33d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7c33d0",
  null
  
)

export default component.exports